import React from "react";
import styled from "styled-components";
import { TaskStatus } from "../../models/workflowModels";
import { BadgeStatus } from "../../enums/Status";
import { statusBadgeColors } from "../../styles";
import flagYellow from "../../assets/svg/flag_yellow.svg";
import flagRed from "../../assets/svg/flag_red.svg";
import flagGreen from "../../assets/svg/flag_green.svg";

type TaskIconProps = {
  color: string;
  size?: number;
};

type TaskKindIconProps = {
  isFlag: boolean;
  status: TaskStatus;
  size?: number;
};

const FlagImage = styled.img<{ $size: number }>`
  display: block;
  width: ${({ $size }): number => $size}px;
  height: ${({ $size }): number => $size}px;
  flex-shrink: 0;
`;

const TaskSvg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

export const FLAG_ICONS: Record<TaskStatus, string> = {
  [TaskStatus.NOT_STARTED]: flagYellow,
  [TaskStatus.IN_PROGRESS]: flagYellow,
  [TaskStatus.STUCK]: flagRed,
  [TaskStatus.COMPLETED]: flagGreen,
};

const TASK_STATUS_BADGE: Record<TaskStatus, BadgeStatus> = {
  [TaskStatus.NOT_STARTED]: BadgeStatus.PLANNED,
  [TaskStatus.IN_PROGRESS]: BadgeStatus.IN_PROGRESS,
  [TaskStatus.STUCK]: BadgeStatus.STUCK,
  [TaskStatus.COMPLETED]: BadgeStatus.COMPLETE,
};

export const taskStatusColor = (status: TaskStatus): string =>
  statusBadgeColors[TASK_STATUS_BADGE[status]].text;

export const TaskIcon = ({ color, size = 14 }: TaskIconProps): JSX.Element => (
  <TaskSvg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true">
    <rect x="1" y="1" width="12" height="12" rx="2.5" fill={color} />
    <path
      d="M4 4.8h6M4 7h6M4 9.2h3.5"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </TaskSvg>
);

export const TaskKindIcon = ({
  isFlag,
  status,
  size = 14,
}: TaskKindIconProps): JSX.Element =>
  isFlag ? (
    <FlagImage src={FLAG_ICONS[status]} alt="" $size={size} />
  ) : (
    <TaskIcon color={taskStatusColor(status)} size={size} />
  );
